import { FormField as CssModulesFormFieldElement, FormFieldProps } from '@sunwebgroup/uds-ui/fields/form-field'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/fields/form-field' instead.
 */
export default Object.assign(
  styled(CssModulesFormFieldElement)<FormFieldProps>``,
  { displayName: 'FormField' },
)
